(function () {
  const DESKTOP_MQ = '(min-width: 1025px)';
  const TRANSITION_MS = 400;
  const SWIPE_GUARD_THRESHOLD = 10;
  const cardStateMap = new WeakMap();
  let lastIsDesktop = isPlpGalleryDesktopBreakpoint();
  let refreshTimerIds = [];
  let initGeneration = 0;

  function isPlpGalleryDesktopBreakpoint() {
    return window.matchMedia(DESKTOP_MQ).matches;
  }

  function isDesktop() {
    return isPlpGalleryDesktopBreakpoint();
  }

  window.mediaQueryPlpGalleryDesktop = DESKTOP_MQ;
  window.isPlpGalleryDesktopBreakpoint = isPlpGalleryDesktopBreakpoint;

  function resetInlineImageStyles(card) {
    const firstImage = card.querySelector('.product-first-image');
    const swiperWrapper = card.querySelector('.product-swiper-wrapper');
    if (firstImage) {
      firstImage.style.removeProperty('display');
    }
    if (swiperWrapper) {
      swiperWrapper.style.removeProperty('display');
    }
  }

  function readImageCount(card) {
    const swiperEl = card.querySelector('.product-card-swiper');
    if (!swiperEl) return 0;
    const dataCount = parseInt(swiperEl.getAttribute('data-image-count') || '0', 10);
    if (!Number.isNaN(dataCount) && dataCount > 0) return dataCount;
    return swiperEl.querySelectorAll('.swiper-slide').length;
  }

  function hasPlpGallery(card) {
    return !!card.querySelector('[data-plp-gallery="true"]');
  }

  function showFirstImage(card) {
    if (isDesktop()) return;
    const firstImage = card.querySelector('.product-first-image');
    const wrapper = card.querySelector('.product-swiper-wrapper');
    if (firstImage) firstImage.style.display = 'block';
    if (wrapper) wrapper.style.display = 'none';
  }

  function showSwiper(card) {
    if (isDesktop()) return;
    const firstImage = card.querySelector('.product-first-image');
    const wrapper = card.querySelector('.product-swiper-wrapper');
    if (firstImage) firstImage.style.display = 'none';
    if (wrapper) wrapper.style.display = 'block';
  }

  function getOrCreateState(card) {
    const existing = cardStateMap.get(card);
    if (existing) return existing;
    const state = {
      swiper: null,
      destroyTimer: null,
      touchStartX: 0,
      touchStartY: 0,
      hasMoved: false,
      pointerTracking: false,
      lastUserSlideIndex: 0,
      touchStartHandler: null,
      moveHandler: null,
      endHandler: null,
      mouseDownHandler: null,
      mouseMoveHandler: null,
      mouseUpHandler: null,
      clickHandler: null,
      pointerEnterHandler: null,
      pointerLeaveHandler: null,
      touchIsolationHandler: null,
      swipeGuardAttached: false,
      touchIsolationAttached: false
    };
    cardStateMap.set(card, state);
    return state;
  }

  function clearDestroyTimer(state) {
    if (state.destroyTimer) {
      window.clearTimeout(state.destroyTimer);
      state.destroyTimer = null;
    }
  }

  function applyZoomClass(swiper, activeIndex) {
    if (!swiper || !swiper.el) return;
    if (activeIndex === 1) {
      swiper.el.classList.add('is-zoom-active');
    } else {
      swiper.el.classList.remove('is-zoom-active');
    }
  }

  function dispatchSlideshowSelect(swiper, previousIndex, userInitiated, trigger) {
    if (!swiper || !swiper.el) return;
    const index = swiper.activeIndex;
    if (index === previousIndex) return;
    swiper.el.dispatchEvent(
      new CustomEvent('slideshow:select', {
        bubbles: true,
        detail: {
          index: index,
          previousIndex: previousIndex,
          userInitiated: !!userInitiated,
          trigger: trigger || 'scroll'
        }
      })
    );
  }

  function refreshSwiper(swiper) {
    if (!swiper || swiper.destroyed) return;
    swiper.allowTouchMove = !isDesktop();
    swiper.update();
    if (swiper.scrollbar && swiper.scrollbar.update) {
      swiper.scrollbar.update();
    }
  }

  function clearRefreshTimers() {
    refreshTimerIds.forEach(function (id) {
      window.clearTimeout(id);
    });
    refreshTimerIds = [];
  }

  function scheduleRefreshTimer(fn, delay) {
    const id = window.setTimeout(fn, delay);
    refreshTimerIds.push(id);
    return id;
  }

  function isSwiperInteracting(swiper) {
    return !!(swiper && (swiper.touching || swiper.animating));
  }

  function scheduleSwiperRefresh(swiper) {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        if (!isSwiperInteracting(swiper)) {
          refreshSwiper(swiper);
        }
      });
    });
  }

  function destroySwiperElement(swiperEl) {
    if (!swiperEl) return;
    if (swiperEl.swiper) {
      swiperEl.swiper.destroy(true, true);
    }
  }

  function ensureSwiper(card) {
    const state = getOrCreateState(card);
    if (state.swiper && !state.swiper.destroyed) return state.swiper;

    const swiperEl = card.querySelector('.product-card-swiper');
    if (!swiperEl || typeof Swiper === 'undefined') return null;

    const imageCount = readImageCount(card);
    if (imageCount <= 1) return null;

    destroySwiperElement(swiperEl);
    state.swiper = null;

    const scrollbarEl = swiperEl.querySelector('.swiper-scrollbar');
    const mobile = !isDesktop();
    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      nested: mobile,
      allowTouchMove: mobile,
      touchEventsTarget: 'container',
      touchStartPreventDefault: false,
      simulateTouch: mobile,
      grabCursor: mobile,
      touchAngle: 45,
      threshold: 5,
      passiveListeners: true,
      preventClicks: true,
      preventClicksPropagation: true,
      observer: false,
      observeParents: false,
      scrollbar: scrollbarEl
        ? {
            el: scrollbarEl,
            draggable: false,
            hide: false
          }
        : false,
      on: {
        init: function () {
          applyZoomClass(this, this.activeIndex);
          scheduleSwiperRefresh(this);
        },
        touchStart: function () {
          this.__plpUserTouch = true;
          this.__plpPrevIndex = this.activeIndex;
        },
        slideChange: function () {
          applyZoomClass(this, this.activeIndex);
          const previousIndex =
            typeof this.__plpPrevIndex === 'number' ? this.__plpPrevIndex : this.previousIndex;
          const userInitiated = !!this.__plpUserTouch;
          if (userInitiated) {
            state.lastUserSlideIndex = this.activeIndex;
          }
          dispatchSlideshowSelect(
            this,
            previousIndex,
            userInitiated,
            userInitiated ? 'scroll' : 'select'
          );
          this.__plpPrevIndex = this.activeIndex;
        },
        touchEnd: function () {
          const self = this;
          window.setTimeout(function () {
            self.__plpUserTouch = false;
          }, 0);
        }
      }
    });

    state.swiper = swiper;
    return swiper;
  }

  function destroySwiper(card) {
    const state = cardStateMap.get(card);
    const swiperEl = card.querySelector('.product-card-swiper');
    if (state && state.swiper) {
      if (!state.swiper.destroyed) {
        state.swiper.destroy(true, true);
      }
      state.swiper = null;
    } else {
      destroySwiperElement(swiperEl);
    }
  }

  function removeSwipeGuard(card, state) {
    const link = card.querySelector('.card__inner > a.full-unstyled-link');
    if (!link || !state.swipeGuardAttached) return;

    if (state.touchStartHandler) {
      link.removeEventListener('touchstart', state.touchStartHandler);
      state.touchStartHandler = null;
    }
    if (state.moveHandler) {
      link.removeEventListener('touchmove', state.moveHandler);
      state.moveHandler = null;
    }
    if (state.endHandler) {
      link.removeEventListener('touchend', state.endHandler);
      state.endHandler = null;
    }
    if (state.clickHandler) {
      link.removeEventListener('click', state.clickHandler, true);
      state.clickHandler = null;
    }
    if (state.mouseDownHandler) {
      link.removeEventListener('mousedown', state.mouseDownHandler);
      state.mouseDownHandler = null;
    }
    if (state.mouseMoveHandler) {
      link.removeEventListener('mousemove', state.mouseMoveHandler);
      state.mouseMoveHandler = null;
    }
    if (state.mouseUpHandler) {
      link.removeEventListener('mouseup', state.mouseUpHandler);
      link.removeEventListener('mouseleave', state.mouseUpHandler);
      state.mouseUpHandler = null;
    }
    state.pointerTracking = false;
    state.swipeGuardAttached = false;
  }

  function markSwipeMovement(state, clientX, clientY) {
    const deltaX = Math.abs(clientX - state.touchStartX);
    const deltaY = Math.abs(clientY - state.touchStartY);
    if (deltaX > SWIPE_GUARD_THRESHOLD && deltaX > deltaY) {
      state.hasMoved = true;
    }
  }

  function setupSwipeGuard(card, state) {
    if (state.swipeGuardAttached) return;

    const link = card.querySelector('.card__inner > a.full-unstyled-link');
    if (!link) return;

    state.moveHandler = function (event) {
      if (!event.touches || !event.touches.length) return;
      const touch = event.touches[0];
      markSwipeMovement(state, touch.clientX, touch.clientY);
    };

    state.endHandler = function () {
      window.setTimeout(function () {
        state.hasMoved = false;
      }, 0);
    };

    state.clickHandler = function (event) {
      if (state.hasMoved) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    state.touchStartHandler = function (event) {
      if (!event.touches || !event.touches.length) return;
      const touch = event.touches[0];
      state.touchStartX = touch.clientX;
      state.touchStartY = touch.clientY;
      state.hasMoved = false;
    };

    state.mouseDownHandler = function (event) {
      if (event.button !== 0) return;
      state.pointerTracking = true;
      state.touchStartX = event.clientX;
      state.touchStartY = event.clientY;
      state.hasMoved = false;
    };

    state.mouseMoveHandler = function (event) {
      if (!state.pointerTracking || event.buttons !== 1) return;
      markSwipeMovement(state, event.clientX, event.clientY);
    };

    state.mouseUpHandler = function () {
      state.pointerTracking = false;
      window.setTimeout(function () {
        state.hasMoved = false;
      }, 0);
    };

    link.addEventListener('touchstart', state.touchStartHandler, { passive: true });
    link.addEventListener('touchmove', state.moveHandler, { passive: true });
    link.addEventListener('touchend', state.endHandler);
    link.addEventListener('mousedown', state.mouseDownHandler);
    link.addEventListener('mousemove', state.mouseMoveHandler);
    link.addEventListener('mouseup', state.mouseUpHandler);
    link.addEventListener('mouseleave', state.mouseUpHandler);
    link.addEventListener('click', state.clickHandler, true);
    state.swipeGuardAttached = true;
  }

  function bindPlpGalleryTouchIsolation(card, state) {
    if (state.touchIsolationAttached) return;
    const gallery = card.querySelector('[data-plp-gallery="true"]');
    if (!gallery) return;

    state.touchIsolationHandler = function (event) {
      event.stopPropagation();
    };

    gallery.addEventListener('touchstart', state.touchIsolationHandler, { passive: true });
    gallery.addEventListener('touchmove', state.touchIsolationHandler, { passive: true });
    state.touchIsolationAttached = true;
  }

  function unbindPlpGalleryTouchIsolation(card, state) {
    if (!state.touchIsolationAttached) return;
    const gallery = card.querySelector('[data-plp-gallery="true"]');
    if (gallery && state.touchIsolationHandler) {
      gallery.removeEventListener('touchstart', state.touchIsolationHandler);
      gallery.removeEventListener('touchmove', state.touchIsolationHandler);
    }
    state.touchIsolationHandler = null;
    state.touchIsolationAttached = false;
  }

  function previewImage(card) {
    const state = getOrCreateState(card);
    clearDestroyTimer(state);
    const swiper = ensureSwiper(card);
    if (!swiper) return;

    const previousIndex = swiper.activeIndex;
    swiper.__plpUserTouch = false;
    card.classList.add('plp-swiper-active');
    swiper.allowTouchMove = false;
    refreshSwiper(swiper);

    const targetIndex =
      typeof state.lastUserSlideIndex === 'number' && state.lastUserSlideIndex > 0
        ? state.lastUserSlideIndex
        : 1;

    swiper.slideTo(targetIndex, 0, false);
    applyZoomClass(swiper, swiper.activeIndex);
    dispatchSlideshowSelect(swiper, previousIndex, false, 'select');

    if (
      swiper.activeIndex !== previousIndex &&
      typeof window.handlePlpProductImageHover === 'function' &&
      typeof window.getPlpProductCardImageContext === 'function'
    ) {
      const gallery = card.querySelector('[data-plp-gallery="true"]');
      const context = window.getPlpProductCardImageContext(gallery || card, swiper.activeIndex + 1);
      if (context) window.handlePlpProductImageHover(context);
    }
  }

  function resetImage(card) {
    const state = cardStateMap.get(card);
    if (!state || !state.swiper || state.swiper.destroyed) return;

    card.classList.remove('plp-swiper-active');
    state.swiper.el.classList.remove('is-zoom-active');
    clearDestroyTimer(state);
    state.destroyTimer = window.setTimeout(function () {
      destroySwiper(card);
    }, TRANSITION_MS);
  }

  function initDesktopCard(card) {
    const state = getOrCreateState(card);
    if (state.pointerEnterHandler || state.pointerLeaveHandler) return;

    state.pointerEnterHandler = function (event) {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      previewImage(card);
    };

    state.pointerLeaveHandler = function (event) {
      if (event.pointerType && event.pointerType !== 'mouse') return;
      resetImage(card);
    };

    card.addEventListener('pointerenter', state.pointerEnterHandler);
    card.addEventListener('pointerleave', state.pointerLeaveHandler);
  }

  function initMobileCard(card) {
    const state = getOrCreateState(card);
    showSwiper(card);
    const swiper = ensureSwiper(card);
    if (!swiper) return false;
    swiper.allowTouchMove = true;
    setupSwipeGuard(card, state);
    bindPlpGalleryTouchIsolation(card, state);
    scheduleSwiperRefresh(swiper);
    return true;
  }

  function removeDesktopEvents(card) {
    const state = cardStateMap.get(card);
    if (!state) return;
    if (state.pointerEnterHandler) {
      card.removeEventListener('pointerenter', state.pointerEnterHandler);
      state.pointerEnterHandler = null;
    }
    if (state.pointerLeaveHandler) {
      card.removeEventListener('pointerleave', state.pointerLeaveHandler);
      state.pointerLeaveHandler = null;
    }
  }

  function destroyCard(card) {
    const state = cardStateMap.get(card);
    if (!state) {
      destroySwiper(card);
      card.removeAttribute('data-plp-swiper-init');
      card.classList.remove('plp-swiper-active');
      resetInlineImageStyles(card);
      return;
    }

    clearDestroyTimer(state);
    removeDesktopEvents(card);
    removeSwipeGuard(card, state);
    unbindPlpGalleryTouchIsolation(card, state);
    destroySwiper(card);
    card.classList.remove('plp-swiper-active');
    resetInlineImageStyles(card);
    card.removeAttribute('data-plp-swiper-init');
    cardStateMap.delete(card);
  }

  function getCards(container) {
    if (!container) return [];
    const scope =
      container.id === 'ProductGridContainer'
        ? container.querySelectorAll('#product-grid .product-card-wrapper.plp-multi-image')
        : container.querySelectorAll(
            '.product-grid-container #product-grid .product-card-wrapper.plp-multi-image'
          );
    return Array.prototype.filter.call(scope, function (card) {
      return hasPlpGallery(card);
    });
  }

  function destroyCardsInContainer(container) {
    getCards(container).forEach(destroyCard);
  }

  function refreshCardsInContainer(container) {
    getCards(container).forEach(function (card) {
      const state = cardStateMap.get(card);
      if (state && state.swiper && !isSwiperInteracting(state.swiper)) {
        refreshSwiper(state.swiper);
      }
    });
  }

  function initCard(card) {
    if (card.getAttribute('data-plp-swiper-init') === 'true') return;
    if (!hasPlpGallery(card)) return;

    const imageCount = readImageCount(card);
    if (imageCount <= 1) {
      resetInlineImageStyles(card);
      return;
    }

    resetInlineImageStyles(card);

    if (isDesktop()) {
      showFirstImage(card);
      initDesktopCard(card);
      card.setAttribute('data-plp-swiper-init', 'true');
    } else if (initMobileCard(card)) {
      card.setAttribute('data-plp-swiper-init', 'true');
    }
  }

  function initializeProductCardSwipers(container, options) {
    const root = container || document;
    const force = options && options.force;
    const defer = options && options.defer;
    const generation = ++initGeneration;

    clearRefreshTimers();

    if (force) {
      destroyCardsInContainer(root);
    }

    const runInit = function () {
      if (generation !== initGeneration) return;

      getCards(root).forEach(initCard);

      if (!isDesktop()) {
        scheduleRefreshTimer(function () {
          if (generation !== initGeneration) return;
          refreshCardsInContainer(root);
        }, 200);
      }
    };

    if (defer) {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(runInit);
      });
    } else {
      runInit();
    }
  }

  function reinitOnBreakpointChange() {
    const nowDesktop = isDesktop();
    if (nowDesktop === lastIsDesktop) return;
    lastIsDesktop = nowDesktop;

    const cards = document.querySelectorAll(
      '.product-grid-container #product-grid .product-card-wrapper.plp-multi-image'
    );
    cards.forEach(function (card) {
      destroyCard(card);
    });

    const plpGrid = document.getElementById('ProductGridContainer');
    initializeProductCardSwipers(plpGrid || document, { defer: true });
  }

  window.destroyPlpProductCardSwipersInContainer = destroyCardsInContainer;
  window.refreshPlpProductCardSwipersInContainer = refreshCardsInContainer;
  window.initializeProductCardSwipers = initializeProductCardSwipers;
  window.initPlpProductCardsInContainer = function (container) {
    initializeProductCardSwipers(container || document, { force: true, defer: true });
  };
  window.bindPlpGalleryTouchIsolation = function (card) {
    if (!card) return;
    bindPlpGalleryTouchIsolation(card, getOrCreateState(card));
  };

  document.addEventListener('DOMContentLoaded', function () {
    const plpGrid = document.getElementById('ProductGridContainer');
    initializeProductCardSwipers(plpGrid || document, { defer: true });
  });

  window.matchMedia(DESKTOP_MQ).addEventListener('change', reinitOnBreakpointChange);
  document.addEventListener('shopify:section:load', function () {
    const plpGrid = document.getElementById('ProductGridContainer');
    initializeProductCardSwipers(plpGrid || document, { defer: true });
  });
})();
